// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { OnDemandSessionsV1 } from './OnDemandSessionsV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface TimedItemLock {
  unlockTime?: number | null;
  relockTime?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ItemDeadline {
  deadline: number;
}

export interface PersonalizedSchedule {
  timedItemLocks: Record<string, TimedItemLock>;
  itemDeadlines: Record<string, ItemDeadline>;
}

export interface OnDemandSessionMembershipsV1 {
  id: string;
  userId: number;
  createdAt: number;
  personalizedSchedule?: PersonalizedSchedule | null;
  courseId?: string | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface OnDemandSessionMembershipsV1Connection {
  elements: Array<OnDemandSessionMembershipsV1> | null;
  linked: {
    onDemandSessionsV1: Array<OnDemandSessionsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface OnDemandSessionMembershipsV1ActiveByUserAndCourseQuery {
  OnDemandSessionMembershipsV1: {
    activeByUserAndCourse: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1ActiveByUserAndCourseQueryVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1AllBySessionQuery {
  OnDemandSessionMembershipsV1: {
    allBySession: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1AllBySessionQueryVariables {
  sessionId: string;
  includeInactive?: string | null;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1BySessionQuery {
  OnDemandSessionMembershipsV1: {
    bySession: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1BySessionQueryVariables {
  sessionId: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1ByUserQuery {
  OnDemandSessionMembershipsV1: {
    byUser: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1ByUserQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1ByUserAndCourseQuery {
  OnDemandSessionMembershipsV1: {
    byUserAndCourse: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1ByUserAndCourseQueryVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1DeleteQuery {
  OnDemandSessionMembershipsV1: {
    delete: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1GetQuery {
  OnDemandSessionMembershipsV1: {
    get: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1MultiGetQuery {
  OnDemandSessionMembershipsV1: {
    multiGet: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface OnDemandSessionMembershipsV1CreateMutation {
  OnDemandSessionMembershipsV1: {
    create: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1CreateMutationVariables {
  skipNotification?: string | null;
  includes?: string | null;
}

export interface OnDemandSessionMembershipsV1SwitchMutation {
  OnDemandSessionMembershipsV1: {
    switch: OnDemandSessionMembershipsV1Connection | null;
  } | null;
}

export interface OnDemandSessionMembershipsV1SwitchMutationVariables {
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class OnDemandSessionMembershipsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandSessionMemberships.v1' as const;

  declare id: string;

  declare userId: number;

  declare createdAt: number;

  declare personalizedSchedule?: PersonalizedSchedule | null;

  declare courseId?: string | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<OnDemandSessionMembershipsV1>) {
    super(params);
  }
}
